import { render, staticRenderFns } from "./EditMilestoneModal.vue?vue&type=template&id=541fbff2&scoped=true&"
import script from "./EditMilestoneModal.vue?vue&type=script&lang=js&"
export * from "./EditMilestoneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541fbff2",
  null
  
)

export default component.exports